// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3MZuN","title":"Header_title__1ZQDw","side":"Header_side__1zFnu"};